import useFreshPlaceData from 'containers/MapDetails/hooks/useFreshPlaceData'
import PlaceElement from '../Result/PlaceElement'
import { selectPlaces } from '../Map/mapSlice'
import { useSelector } from 'react-redux'

const Place = ({ placeId, expanded, placeDetailsRef }) => {
  useFreshPlaceData()

  const places = useSelector(selectPlaces)
  const place = <PlaceElement
    key={placeId}
    expanded={expanded}
    placeDetailsRef={placeDetailsRef}
    data={places.find(({ id }) => id === placeId)}
  />

  return (
    <div className='map__result'>
      <div className='result__header'>
        <div
          className='header__main'
          style={{
            padding: 0,
            backgroundColor: 'var(--theme-sec-bg)'
          }}>
          <div
            key={`${expanded}`}
            className='list --simple'
            style={{ gap: 0 }}>
            {place}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Place